var Combobox = window.Combobox = (function () {
	function Combobox(datalist, input) {
		if (!input) {
            app.console.error('You should declare a main input unique selector');
			return;
		}

		var self = this;

		if (datalist && Array.isArray(datalist)) {
			self.datalist = datalist;
		}

        self.isPreventedOpening = false;
		self.input = input;
		self.checksum = Math.random();
		self.input.attr('data-combobox-checksum', self.checksum);

		self.wrapper = $('<div/>', {
			'class': 'combobox-input-wrapper'
		});

		input.wrap(self.wrapper);

		self.isOpen = false;

		$(self.input).on('click', function (e) {
            if(self.isPreventedOpening) {
                return;
            }

			if ($(this).hasClass('open')) {
			    self.close();
			} else {
				self.open();
				$(this).addClass('open');
			}
		});
	};

	Combobox.prototype.open = function () {
	    $(document).on('click.combobox', function (e) {
	        var checksum = $(e.target).attr('data-combobox-checksum');

	        if (!checksum === undefined || checksum != self.checksum) {
	            self.close();
	        }
	    });

	    var self = this;
	    this.draw();

	    this.input.addClass('open');

		this.container.addClass('open');
		this.isOpen = true;

		this.input.on('keyup.combobox', function () {
			self.close();
		});

	}

	Combobox.prototype.close = function () {
	    this.input.removeClass('open');
	    this.container.removeClass('open');
	    this.container.remove();
	}

    Combobox.prototype.preventOpening = function(value) {
        this.isPreventedOpening = value;
    }

	Combobox.prototype.setValue = function (title) {
		$(this.input).val(title);
		$(this.input).change();
	}

	Combobox.prototype.draw = function () {
		var self = this;

		self.container = $('<div/>', {
			'class': 'combobox-container'
		});

		for (var i = 0; i < this.datalist.length; i++) {
			var item = $('<div/>', {
				'class': 'combobox-container__item'
			}).html(self.datalist[i]);
			self.container.append(item);
		}

		self.container.insertAfter(self.input);

		self.container.on('click', '.combobox-container__item', function (e) {
			if ($(e.target).hasClass('combobox-container__item')) {
				var title = $(this).html();
				self.setValue(title);
			}
		});
	}

	return Combobox;
}());